import React, {Component} from 'react';
import {AppBar, Box, Grid, Tab, Tabs, Toolbar} from "@material-ui/core";
import {MainContext} from "contexts/main.context";
import {Excel} from "./excel";
import {Plantilla} from "./plantilla";
import {Route, Switch} from 'react-router-dom';
import SubHeader from "../../helpers/subHeader/subHeader";

const basePath = '/stock/listasPrecio';

export class ListasPrecio extends Component {
    state = {
        tabActive: 'excel'
    };

    componentDidMount() {
        if (this.props.location.pathname.indexOf('plantilla') > -1)
            this.setState({tabActive: 'plantilla'});
    }

    changeTab = (event, value) => {
        this.setState({tabActive: value});
        this.props.history.push(`${this.props.match.url}/${value}`);
    };

    render() {
        const {tabActive} = this.state;
        return (
            <div className='niquel-stock-listasPrecio'>
                <SubHeader
                    title={'Listas de Precio'}
                />
                <AppBar position="relative" elevation={0}>
                    <Toolbar variant="dense" color='primary'>
                        <Grid container justifyContent="space-between" alignItems="center">
                            <Grid item>
                                <Tabs
                                    value={tabActive}
                                    onChange={this.changeTab}
                                    indicatorColor="secondary"
                                    textColor="inherit"
                                >
                                    {["A", "O"].includes(this.context.loggedUser.role) && (
                                        <Tab label="Plantilla" value='plantilla'/>
                                    )}
                                    <Tab label="Excel" value='excel'/>
                                </Tabs>
                            </Grid>
                        </Grid>
                    </Toolbar>
                </AppBar>
                <Box className='container-xl mt-3 mb-3'>
                    <Switch>
                        <Route path={`${basePath}/plantilla`} component={Plantilla}/>
                        <Route path={`${basePath}`} component={Excel}/>
                    </Switch>
                </Box>
            </div>
        )
    }
}

ListasPrecio.contextType = MainContext;
